<template>
	<div class="schedule-component">
		<div class="mb-4">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item">
						<a :href=route_back>Реестр образов</a>
					</li>
					<li class="breadcrumb-item active" aria-current="page">Редактировать образ</li>
				</ol>
			</nav>
		</div>

        <div class="two-col-container">
            <div class="left-col">
                <div class="schedule-component__select mb-4">
                    <label class="form-label">Название <span class="color-red">*</span></label>
                    <input v-model="name" type="text" placeholder="Образ для ТВ Ubuntu 24" class="form-control" required>
                </div>

                <div class="schedule-component__select mb-4">
                    <div class="form-label">Версия ПО <span class="color-red">*</span></div>
                    <v-select class="select"
                              placeholder="Выберите версию ПО"
                              v-model="deviceSoftwareVersionId"
                              :items="deviceSoftwareVersions"
                              item-title="number"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <label class="form-label">Дата сборки <span class="color-red">*</span></label>
                    <input v-model="buildDate" type="date" class="form-control" required>
                </div>

                <div class="schedule-component__text-input mb-4">
                    <div class="form-label">Описание <span class="color-red">*</span></div>
                    <textarea cols="30" rows="5" class="form-control" v-model="description" placeholder="Информация об образе" required></textarea>
                </div>

                <div class="form-check mb-4">
                    <label for="is-archived" class="form-check-label">
                        <span>Архивный образ</span>
                        <input class="form-check-input" type="checkbox" id="is-archived" v-model="isArchived" :checked="isArchived">
                    </label>
                </div>

                <div class="schedule-component__text-input mb-4">
                    <p>Количество устройств(установлено/подходит) рассчитывается автоматически.</p>
                </div>

                <div class="schedule-component__btns">
                    <ConfirmBtn :class="'btn btn-lg btn-primary'" :text="'Сохранить'" @btnClick="edit"/>
                    <a type="button" class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>
        </div>
	</div>
    <Alert />
</template>

<script>
import axios from 'axios';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';

export default {
    name: 'DeviceImagesEditComponent',
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_update: String,
        route_show: String,
        route_device_software_versions: String,
        device_image_id: {
            type: [Number, String],
        }
    },
	data() {
		return {
            name: null,
            description: '',
            buildDate: null,
            deviceSoftwareVersionId: null,
            deviceSoftwareVersions: [],
            isArchived: false,
		}
	},
	methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        getDeviceImage: async function() {
            try {
                const response = await axios.get(this.route_show);

                if (!response.data.data) {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Что-то пошло не так, не удалось получить данные' });
                    return;
                }

                const data = response.data.data;

                this.name = data.name;
                this.buildDate = data.build_date;
                this.description = data.description;
                this.deviceSoftwareVersionId = data.device_software_version_id;
                this.isArchived = !data.is_active;
            } catch (error) {
                console.error('Error in getRelease:', error);
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Ошибка при загрузке данных релиза' });
            }
        },
        getDeviceSoftwareVersions: async function () {
            let response = await axios.get(this.route_device_software_versions);
            this.deviceSoftwareVersions = response.data.data;
        },
        edit: async function () {
            this.isButtonDisabled = true;
            if (this.deviceSoftwareVersionId === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете версию!' });
                this.toggleLoading();
                return;
            }

            if (this.buildDate === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете дату сборки!' });
                this.toggleLoading();
                return;
            }

            if (this.description === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте описание релиза!' });
                this.toggleLoading();
                return;
            }

            if (this.description.length < 10) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Слишком короткое описание. Минимальное количество символов не менее 10.' });
                this.toggleLoading();
                return;
            }

            let updated = await axios.put(
                this.route_update,
                {
                    id: this.device_image_id,
                    name: this.name,
                    device_software_version_id: this.deviceSoftwareVersionId,
                    build_date: this.buildDate,
                    description: this.description,
                    is_archived: this.isArchived
                }
            );

            if (updated.data.data) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: updated.data.message });
                this.toggleLoading();
            }
        },
    },

    mounted() {
      this.getDeviceImage();
      this.getDeviceSoftwareVersions();
    }
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
        &__btns {
            margin-left: auto;
            display: flex;
            gap: 6px;
        }
	}
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.schedule-component {
		&__select {
			max-width: 400px;
		}
        &__text-input {
            @extend.schedule-component__select;
        }
		&__btns {
			display: flex;
			gap: 16px;
			button {
				width: 214px;
			}
		}
		&__selected-items {
			display: flex;
			flex-direction: column;
			max-height: 170px;
			max-width: 710px;
			overflow-y: auto;
			gap: 10px;
			.selected-item {
				display: flex;
				align-items: center;
				justify-content: center;
				&__text {
					font-size: 16px;
					font-weight: 400;
					color: #0678F4;
				}
				&__icon {
					margin-left: auto;
					margin-right: 6px;
					min-height: 20px;
					min-width: 20px;
					cursor: pointer;
					transition: 0.2s;
					&:hover {
						color: red;
						transition: 0.2s;
					}
				}
			}
		}
	}
	.tabs {
		&__log-ctls {
			gap: 10px !important;
		}
	}
    .form-check {
        display: flex;
        gap: 8px;
        align-items: center;
    }
</style>
